const API_URL = process.env.REACT_APP_API_URL;
const ID_SITE = process.env.REACT_APP_SITE_ID;
const SITE_GIT = process.env.REACT_APP_SITE_GIT;
const SITE_TDH = process.env.REACT_APP_SITE_TDH;
const SITE_CCO = process.env.REACT_APP_SITE_CCO;
const SHOW_DETAILS = process.env.SHOW_DETAILS;
const BACKOFFICEURL = process.env.BACKOFFICEURL;
const API_KEY_MAPS = process.env.API_KEY_MAPS;
const MAP_ID_MAPS = process.env.MAP_ID_MAPS;
const SHOW_FLI = process.env.SHOW_FLI;
const COLLEGEURL = process.env.COLLEGEURL;
const PIXEL_ID = process.env.PIXEL_ID;
const ACCESS_TOKEN = process.env.ACCESS_TOKEN;
const ENV = process.env.ENV;
const WEBSOCKET_URL = process.env.WEBSOCKET_URL;
const REACT_APP_API_URL_ORG = process.env.REACT_APP_API_URL_ORG;
const AUX_VALIDATE_HOTEL = process.env.AUX_VALIDATE_HOTEL;
const SSK = process.env.SIGN_SECRET_KEY;

export {
  API_URL,
  ID_SITE,
  SITE_GIT,
  SITE_TDH,
  SITE_CCO,
  SHOW_DETAILS,
  BACKOFFICEURL,
  API_KEY_MAPS,
  MAP_ID_MAPS,
  SHOW_FLI,
  COLLEGEURL,
  PIXEL_ID,
  ACCESS_TOKEN,
  ENV,
  WEBSOCKET_URL,
  REACT_APP_API_URL_ORG,
  AUX_VALIDATE_HOTEL,
  SSK,
};
